/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import Meta from "vue-meta";

// Routes
import paths from "./paths";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// Create a new router
const router = new Router({
  base: "/",
  mode: "history",
  hashbang: "false",
  routes: paths,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});
router.mode = "html5";

// Route guard checks to see if you are logged in, if not reroutes to login
// to is where you are going, matched.some is to find which routes have requiresAuth
router.beforeEach((to, from, next) => {
 
  if (store.getters.authstatus == "success") {
    if (to.name === "otp") {
      return next({ path: from.path });
    }
    if (from.path !== "/" && (to.name === "home" || to.name === "login")) {
      var isAuth =
        window.sessionStorage.getItem("BearerToken") == null ? false : true;

      var storage = window.sessionStorage;
      console.log(storage);
      if (isAuth) {
        const answer = window.confirm(
          "Uygulamadan ayrılmak istediğinize emin misiniz ?"
        );
        console.log(answer);
        if (answer) {
          next();
        } else {
          return false;
        }
      }
    }
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.authorized && store.getters.authstatus == "success") {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});

Vue.use(Meta);

export default router;
